<template>
  <div class="vap-page">
    <Loading
      :active.sync="isLoading"
      :is-full-page="false"
      :color="loaderColor"
      loader="dots"
      :background-color="loaderBackgroundColor"
    />
    <div class="vap-page-header">
      <h1>Group Management</h1>
      <div class="btns-container">
        <VasionButton classProp="primary" @vasionButtonClicked="newGroupClick">
          {{ newGroupButtonLabel }}
        </VasionButton>
      </div>
    </div>
    <div class="vap-page-content">
      <div class="tabs-list-container">
        <VasionButton
          v-for="(tab, tabIndex) in tabs"
          :id="`tab-group-${tab.name}`"
          :key="tabIndex"
          :classProp="activeTab === tab.name ? 'text-selected' : 'text'"
          @vasionButtonClicked="setActiveTab(tab.name)"
        >
          {{ tab.label }}
        </VasionButton>
      </div>
      <div class="tabs-item-container">
        <GroupsTabContent ref="refGroupsTabContent" />
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { loaderBackgroundColor, loaderColor } from '@/assets/js/styleConfig'
import GroupsTabContent from '@/views/admin/securityPermissions/GroupsTabContent.vue'

export default {
  name: 'Groups',
  components: {
    GroupsTabContent,
    Loading,
  },
  data: function () {
    return {
      activeTab: null,
      isLoading: false,
      loaderBackgroundColor: loaderBackgroundColor,
      loaderColor: loaderColor,
      tabs: [
        { name: 'internal', label: 'Internal' },
        { name: 'portal', label: 'Portal' },
      ],
    }
  },
  computed: {
    isExternalUserPortalAdminEnabled() {
      return this.$store.state.systemSettings.featureFlags.enablePortalUsersAdmin
    },
    newGroupButtonLabel() {
      return this.activeTab === 'portal' ? 'New Portal Group' : 'New Group'
    },
  },
  async created() {
    // TODO: Remove after finishing the development of External User Portal
    if (!this.isExternalUserPortalAdminEnabled) {
      this.tabs = this.tabs.filter(tab => tab.name !== 'portal')
    }
    await this.loadInitialData()
    // Set default tab
    const defaultTabToSet = 'internal'
    const internalTab = this.tabs.find(tab => tab.name === defaultTabToSet)
    this.activeTab = internalTab ? internalTab.name : this.tabs[0].name
  },
  beforeDestroy() {
    this.$store.dispatch('security/setGroupType', 'internal')
  },
  methods: {
    handleExportGroupsList() {
      console.log('Export Groups List button clicked')
    },
    hideLoading() {
      this.setLoading(false)
    },
    async loadInitialData() {
      this.showLoading()
      try {
        await this.$store.dispatch('security/loadGroupList')
        this.$refs.refGroupsTabContent?.refreshTable()
        this.hideLoading()
      } catch (error) {
        console.error('Error loading initial data:', error)
        this.hideLoading()
      }
    },
    newGroupClick() {
      this.$refs.refGroupsTabContent?.editGroupClick(0)
    },
    async setActiveTab(tabName) {
      const tab = this.tabs.find(tab => tab.name === tabName)
      this.activeTab = tab ? tab.name : this.tabs[0].name

      await this.$store.dispatch('security/setGroupType', this.activeTab)
    },
    setLoading(isLoading) {
      this.isLoading = isLoading
    },
    showLoading() {
      this.setLoading(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.vap-page-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
}

.tabs-list-container {
  flex-shrink: 0;
}
.tabs-list-container ::v-deep button:first-of-type {
  margin-left: 0;
}
.tabs-list-container ::v-deep button:last-of-type {
  margin-right: 0;
}

.tabs-item-container {
  flex-grow: 1;
  overflow-y: auto;
  height: 100%;
}
</style>
